import React, { Component } from 'react';
import { EditorState, convertToRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import { connect } from 'react-redux'
import { getCont } from '../actions/contentActions'
import draftToHtml from 'draftjs-to-html';
import '../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

class MyEditor extends Component {
  constructor(props){
    super(props)
    this.state = {
      editorState: EditorState.createEmpty(),
      content: ''
    }
  }

  onEditorStateChange: Function = (editorState) => {
    this.setState({
      editorState,
    });
    this.setState({content: draftToHtml(convertToRaw(editorState.getCurrentContent()))})
    this.props.dispatch(getCont(this.state.content))
  };

  render() {
    const { editorState } = this.state;
    return (
      <div className={'border-grey'}>
        <Editor
          wrapperClassName={'border-blue-ititoca'}
          toolbarClassName={'bg-ititoca'}
          editorState={editorState}
          onEditorStateChange={this.onEditorStateChange}
        />
        {/* <textarea disabled value={draftToHtml(convertToRaw(editorState.getCurrentContent()))} /> */}
      </div>
    );
  }
}

export default connect()(MyEditor)



// WEBPACK FOOTER //
// ./src/components/Draft.js